import { Injectable } from '@angular/core';
import { AdminChallenge, DailyChallenge, HistoryUserChallenge, MonthlyChallenge } from './models/challenges.response';
import {
  AdminChallengeContent,
  Challenge,
  ChallengeHistory,
  ChallengeScope,
  ChallengeType,
  DailyChallengeContent,
  MonthlyChallengeContent
} from './models/challenges.model';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class ChallengesFactory {
  constructor(
    private readonly translateService: TranslateService,
  ) {
  }

  buildAdminChallenge(data: AdminChallenge, isPublic = false): Challenge<AdminChallengeContent> {
    return {
      id: data.id,
      contents: data.contents,
      creationDate: data.startDate,
      expirationDate: data.endDate,
      isPublic,
      name: data.name,
      progress: data.progress,
      scope: ChallengeScope.ADMIN,
      target: data.target,
      type: ChallengeType[data.type],
    };
  }

  buildDailyChallenge(data: DailyChallenge): Challenge<DailyChallengeContent> {
    return {
      contents: data.pastDaysAchievements,
      creationDate: data.creationDate,
      isPublic: false,
      name: this.translateService.instant('challenges.dailyGoalTitle'),
      progress: data.progress,
      scope: ChallengeScope.DAILY,
      target: data.targetMinutes,
      type: ChallengeType.READING_TIME_CHALLENGE,
    };
  }

  buildMonthlyChallenge(data: MonthlyChallenge): Challenge<MonthlyChallengeContent> {
    return {
      contents: data.titlesCompleted,
      creationDate: data.creationDate,
      isPublic: false,
      name: this.translateService.instant('challenges.monthlyTitle'),
      progress: data.progress,
      scope: ChallengeScope.MONTHLY,
      target: data.targetTitles,
      type: ChallengeType.TITLES_READ_CHALLENGE,
    };
  }

  buildHistoryUserChallenge(data: HistoryUserChallenge): ChallengeHistory {
    return {
      ...data,
      items: data.items.map((item) => this.buildAdminChallenge(item))
    };
  }
}
